// extracted by mini-css-extract-plugin
module.exports = {"table-header":"AppTable_table-header__CE_W6","table-container":"AppTable_table-container__WcM2D","container":"AppTable_container__1cuFb","split":"AppTable_split__5vEJf"};